/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-05 22:03:17
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 00:22:36
 * @FilePath: /wemeet-web-activity/src/utils/validator.tsx
 * @Description: 统一校验字段
 */
export class Validator {
  static isPhone(v) {
    return v && /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(v);
  }
  static isEmail(v) {
    return v && /^[\w.-]+@[0-9a-z-]+(\.[a-z]+){1,2}$/.test(v);
  }
  static isUserName(v) {
    return v && v.length <= 20;
  }
  static isSmsCode(v) {
    return v && /\d{4}/.test(v);
  }
}